import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';
import ApiGuide from './ApiGuide';
import { downloadPostmanCollection } from '../utils/postmanCollection';
import './Header.css';

const Header: React.FC = () => {
  const location = useLocation();
  const [isGuideOpen, setIsGuideOpen] = useState(false);

  return (
    <>
      <header className="app-header">
        <div className="header-left">
          <div className="logo-section">
            <div className="logo-version-row">
              <Logo />
              <span className="version-badge">v1.0</span>
            </div>
          </div>
        </div>

        <div className="header-right">
          <nav className="header-nav">
            <Link
              to="/"
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
            >
              📚 Documentation
            </Link>
            <Link
              to="/demo"
              className={`nav-link ${location.pathname === '/demo' ? 'active' : ''}`}
            >
              🧪 API Demo
            </Link>
            <Link
              to="/report-demo"
              className={`nav-link ${location.pathname === '/report-demo' ? 'active' : ''}`}
            >
              📄 Report Demo
            </Link>
          </nav>
          <button
            className="postman-button"
            onClick={downloadPostmanCollection}
            title="Download Postman Collection JSON"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6 }}>
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Postman Collection
          </button>
          <button className="guide-button" onClick={() => setIsGuideOpen(true)}>
            📖 API Guide
          </button>
        </div>
      </header>

      <ApiGuide isOpen={isGuideOpen} onClose={() => setIsGuideOpen(false)} />
    </>
  );
};

export default Header;


